(() => {
  'use strict';

  const COVER_PRODUCT_ID = 10532131668304;
  const COVER_VARIANT_ID = 53152763314512;
  const ELIGIBLE_RACKET_VARIANT_IDS = new Set([
    53143305191760, // Viper V1 - Red 18K
    53143234216272, // Strike V2 - White 18K
    53143302603088, // Flow V1 - Purple 3K
  ]);
  const ESSENTIAL_UPSELL_FUNNEL_ID = 'af9f158b-5eec-4ae3-bba7-03b3e06d74d5';
  const FUNNEL_PROPERTY = '__essential_upsell_funnel_id';
  const PRODUCT_PROPERTY = '__essential_upsell_product_id';
  const LEGACY_GIFT_PROPERTY = '_cobra_free_cover';
  const EVENT_SOURCE = 'cobra-free-racket-cover';
  const nativeFetch = window.fetch.bind(window);

  let syncTimer;
  let syncing = false;
  let syncAgain = false;

  const shopRoot = () => window.Shopify?.routes?.root || '/';
  const cartJsonUrl = () => `${shopRoot()}cart.js`;
  const cartAddUrl = () => window.routes?.cart_add_url || `${shopRoot()}cart/add.js`;
  const cartChangeUrl = () => window.routes?.cart_change_url || `${shopRoot()}cart/change.js`;
  const cartUpdateUrl = () => window.routes?.cart_update_url || `${shopRoot()}cart/update.js`;

  function isGiftLine(item) {
    return (
      Number(item.id) === COVER_VARIANT_ID &&
      (item.properties?.[FUNNEL_PROPERTY] === ESSENTIAL_UPSELL_FUNNEL_ID ||
        item.properties?.[LEGACY_GIFT_PROPERTY] === 'true')
    );
  }

  function hasDiscountProperties(item) {
    return item.properties?.[FUNNEL_PROPERTY] === ESSENTIAL_UPSELL_FUNNEL_ID;
  }

  function giftProperties() {
    return {
      [FUNNEL_PROPERTY]: ESSENTIAL_UPSELL_FUNNEL_ID,
      [PRODUCT_PROPERTY]: String(COVER_PRODUCT_ID),
    };
  }

  function desiredGiftQuantity(cart) {
    return cart.items.some(
      (item) => item.quantity > 0 && ELIGIBLE_RACKET_VARIANT_IDS.has(Number(item.id))
    )
      ? 1
      : 0;
  }

  async function fetchCart() {
    const response = await nativeFetch(cartJsonUrl(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) throw new Error(`Cart could not be read (${response.status})`);
    return response.json();
  }

  function sectionRequest() {
    const names = new Set(['cart-icon-bubble']);
    const cartItems = document.getElementById('main-cart-items');
    const cartFooter = document.getElementById('main-cart-footer');

    if (cartItems?.dataset.id) {
      names.add(cartItems.dataset.id);
      if (cartFooter?.dataset.id) names.add(cartFooter.dataset.id);
      names.add('cart-live-region-text');
    } else if (document.querySelector('cart-drawer')) {
      names.add('cart-drawer');
    } else if (document.getElementById('cart-notification-button')) {
      names.add('cart-notification-button');
    }

    return Array.from(names).slice(0, 5);
  }

  function sectionElement(html, selector) {
    if (!html) return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  function replaceSectionInnerHtml(target, html, selector) {
    const source = target && sectionElement(html, selector);
    if (source) target.innerHTML = source.innerHTML;
  }

  function renderUpdatedSections(response, cart) {
    const sections = response.sections || {};
    const cartItems = document.getElementById('main-cart-items');
    const cartFooter = document.getElementById('main-cart-footer');
    const cartIsEmpty = cart.item_count === 0;

    replaceSectionInnerHtml(
      document.getElementById('cart-icon-bubble'),
      sections['cart-icon-bubble'],
      '.shopify-section'
    );

    replaceSectionInnerHtml(
      document.getElementById('cart-notification-button'),
      sections['cart-notification-button'],
      '.shopify-section'
    );

    if (cartItems?.dataset.id) {
      replaceSectionInnerHtml(
        cartItems.querySelector('.js-contents') || cartItems,
        sections[cartItems.dataset.id],
        '.js-contents'
      );
      cartItems.closest('cart-items')?.classList.toggle('is-empty', cartIsEmpty);
    }

    if (cartFooter?.dataset.id) {
      replaceSectionInnerHtml(
        cartFooter.querySelector('.js-contents') || cartFooter,
        sections[cartFooter.dataset.id],
        '.js-contents'
      );
      cartFooter.classList.toggle('is-empty', cartIsEmpty);
    }

    replaceSectionInnerHtml(
      document.getElementById('cart-live-region-text'),
      sections['cart-live-region-text'],
      '.shopify-section'
    );

    const cartDrawer = document.querySelector('cart-drawer');
    cartDrawer?.classList.toggle('is-empty', cartIsEmpty);

    if (cartDrawer && sections['cart-drawer']) {
      replaceSectionInnerHtml(
        cartDrawer.querySelector('#CartDrawer'),
        sections['cart-drawer'],
        '#CartDrawer'
      );
      cartDrawer
        .querySelector('#CartDrawer-Overlay')
        ?.addEventListener('click', () => cartDrawer.close());
    }
  }

  async function updateGift(cart, desiredQuantity) {
    const giftLines = cart.items.filter(isGiftLine);
    const sections = sectionRequest();
    const common = {
      sections,
      sections_url: window.location.pathname,
    };

    let url;
    let body;

    if (desiredQuantity > 0 && giftLines.length === 0) {
      url = cartAddUrl();
      body = {
        ...common,
        items: [
          {
            id: COVER_VARIANT_ID,
            quantity: desiredQuantity,
            properties: giftProperties(),
          },
        ],
      };
    } else if (
      desiredQuantity > 0 &&
      giftLines.length > 0 &&
      !hasDiscountProperties(giftLines[0])
    ) {
      url = cartChangeUrl();
      body = {
        ...common,
        id: giftLines[0].key,
        quantity: desiredQuantity,
        properties: giftProperties(),
      };
      if (giftLines.length > 1) syncAgain = true;
    } else {
      const updates = {};
      giftLines.forEach((line, index) => {
        updates[line.key] = index === 0 ? desiredQuantity : 0;
      });

      url = cartUpdateUrl();
      body = { ...common, updates };
    }

    const response = await nativeFetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    });

    const result = await response.json();
    if (!response.ok || result.status) {
      throw new Error(result.description || result.message || 'Cover could not be updated');
    }

    const updatedCart = await fetchCart();
    renderUpdatedSections(result, updatedCart);

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      await publish(PUB_SUB_EVENTS.cartUpdate, {
        source: EVENT_SOURCE,
        cartData: updatedCart,
      });
    }
  }

  async function syncGift() {
    if (syncing) {
      syncAgain = true;
      return;
    }

    syncing = true;

    try {
      const cart = await fetchCart();
      const desiredQuantity = desiredGiftQuantity(cart);
      const giftLines = cart.items.filter(isGiftLine);
      const giftQuantity = giftLines.reduce((total, line) => total + line.quantity, 0);
      const discountPropertiesMissing = giftLines.some(
        (line) => !hasDiscountProperties(line)
      );

      if (
        giftQuantity !== desiredQuantity ||
        (giftLines.length > 1 && desiredQuantity > 0) ||
        (desiredQuantity > 0 && discountPropertiesMissing)
      ) {
        await updateGift(cart, desiredQuantity);
      }
    } catch (error) {
      console.warn('[Cobra Padel] Automatic racket cover:', error);
    } finally {
      syncing = false;

      if (syncAgain) {
        syncAgain = false;
        queueSync(100);
      }
    }
  }

  function queueSync(delay = 80) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncGift, delay);
  }

  function isCartMutation(input) {
    try {
      const rawUrl = typeof input === 'string' ? input : input?.url;
      const pathname = new URL(rawUrl, window.location.origin).pathname;
      return /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(pathname);
    } catch (_) {
      return false;
    }
  }

  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);
    if (response.ok && isCartMutation(args[0])) queueSync();
    return response;
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source !== EVENT_SOURCE) queueSync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => queueSync(0), { once: true });
  } else {
    queueSync(0);
  }

  window.addEventListener('pageshow', () => queueSync(0));
})();
